import Progress from './progress';
export default Progress;
//# sourceMappingURL=index.js.map
